import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ children, isLoginRoute = false }) => {
  const auth = useSelector((state) => state.auth);
  const isAuthenticated = auth?.isAuthenticated;
  const userType = auth?.user?.type;

  if (isAuthenticated && isLoginRoute) {
    if (userType === "superadmin") {
      return <Navigate to="/admin-panel" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }

  if (!isAuthenticated && !isLoginRoute) {
    return <Navigate to="/login" replace />;
  }

  if (!isLoginRoute) {
    if (userType === "superadmin") {
      return <Navigate to="/unauthorized" replace />;
    }
    if (userType !== "client" && userType !== "admin_user") {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
